import React from 'react';
import { ListGroup } from 'react-bootstrap';

import Item from './Item';

const ColumnsOrder = (props) => {
  const { data, selections, horizontal } = props;
  const columns = selections.length !== 0 ? selections.concat(data) : data;

  const handleOnClick = (event) => {
    let newData = [];
    let newSelections = [];

    if (event?.checked === true) {
      newData = data.concat({
        ...event,
        checked: false,
      });

      newSelections = selections.filter((item) => {
        return item.key !== event.key;
      });
    } else {
      newData = data.filter((item) => {
        return item.key !== event.key;
      });

      newSelections = selections.concat({
        ...event,
        checked: true,
      });
    }

    props.onChange(newData, newSelections);
  };

  return (
    <ListGroup
      className="ml-2 table-responsive"
      horizontal={horizontal}
    >
      {columns.map((column) => (
        <Item
          key={column.key}
          data={column}
          onRowClick={handleOnClick}
        ></Item>
      ))}
    </ListGroup>
  );
};

export default ColumnsOrder;
